import { Section } from "@/components/molecules/section";
import { useTranslation } from "@/features/utils/i18n";
import { ApiKeysTable } from "./components/api-keys-table";
import { EmailTable } from "./components/email-table";
import { PasswordTable } from "./components/password-table";
import { PhoneTable } from "./components/phone-table";
import { WebAuthnDevicesTable } from "./components/webauthn-devices-table";

export const SecuritySection = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      <Section
        title={t("security.password.title")}
        description={t("security.password.description")}
      >
        <PasswordTable />
      </Section>

      <Section
        title={t("security.emailAddresses.title")}
        description={t("security.emailAddresses.description")}
      >
        <EmailTable />
      </Section>

      <Section
        title={t("security.securityKeys.title")}
        description={t("security.securityKeys.description")}
      >
        <WebAuthnDevicesTable />
      </Section>

      <Section
        title={t("security.phoneNumbers.title")}
        description={t("security.phoneNumbers.description")}
      >
        <PhoneTable />
      </Section>

      <Section
        title={t("security.apiKeys.title")}
        description={t("security.apiKeys.description")}
      >
        <ApiKeysTable />
      </Section>
    </div>
  );
};
